import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';

import Loading from '../Loading/LoadingView';
import AdvForm from '../../CommonComponents/AdvForm';
import ValidationErrors from '../ValidationErrors/ValidationErrorsContainer';
import PlanImpact from '../PlanImpact/PlanImpactContainer';
import Footer from '../Footer/FooterContainer';
import { isNumeric, isUuid, createCustomPropType } from '../../../js/app/react/validators';
import {
  simpleSelectDefaultValue,
  simpleSelectChangedToNonNull,
} from '../../Profile/Accounts_react/AccountsUtils';
import { Select } from '../../CommonComponents/OPL/Select/Select/Select';

class SelectionWhatifView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;

    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;

    const impactTriggerProps = ['whatIf', 'fpId'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      loading,
      groupTitle,
      clientId,
      title,
      areOptionsLoaded,
      label,
      id,
      options,
      planImpactItems,
      fpId,
      goalId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      value,
      storeData,
      valueStorePath,
    } = this.props;

    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-form-field">
                <label className="what-ifs-label" htmlFor={id}>
                  <span className="what-ifs-label-text">{label}</span>
                  <br />
                  <Select
                    id={id}
                    value={simpleSelectDefaultValue(options, value)}
                    onChange={simpleSelectChangedToNonNull(
                      clientId,
                      storeData(goalId, whatIfTemplate.WhatIfType),
                      valueStorePath,
                    )}
                    options={options}
                    isPortal
                  />
                </label>
              </li>
            </ul>
          </AdvForm>
        </div>

        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />

        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

SelectionWhatifView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

SelectionWhatifView.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
  valueStorePath: PropTypes.string.isRequired,
};

export default SelectionWhatifView;
